import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import TermLifePage from './pages/TermLifePage';
import WholeLifePage from './pages/WholeLifePage';
import MillionDollarPage from './pages/MillionDollarPage';
import FinalExpensePage from './pages/FinalExpensePage';
import NoMedicalExamPage from './pages/NoMedicalExamPage';
import IULPage from './pages/IULPage';
import './index.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/term-life-insurance" element={<TermLifePage />} />
        <Route path="/whole-life-insurance" element={<WholeLifePage />} />
        <Route path="/million-dollar-life-insurance" element={<MillionDollarPage />} />
        <Route path="/final-expense-insurance" element={<FinalExpensePage />} />
        <Route path="/no-medical-exam-insurance" element={<NoMedicalExamPage />} />
        <Route path="/indexed-universal-life-insurance" element={<IULPage />} />
      </Routes>
    </Router>
  );
}

export default App;